module.exports = __webpack_public_path__ + "static/media/elan.539d1b35.jpg";